import { FormattedMessage } from "react-intl";
import { isSomething } from "../../utils";

type Props = {
  assignableId: number;
  assignableType: string;
  onCreate: $TSFixMeFunction;
  onDelete: $TSFixMeFunction;
  disabled?: boolean;
  permissionId?: number;
  permissionType: string;
  permitableId: number;
};

function PermissionEdit({
  permissionType,
  permitableId,
  onDelete,
  onCreate,
  assignableId,
  assignableType,
  permissionId,
  disabled,
}: Props) {
  const id = `${permissionType}_${permitableId}_${assignableType}_${assignableId}`;
  const labelId = `permission_type.${permissionType}`;

  const handleOnChange = () => {
    if (isSomething(permissionId)) {
      onDelete(permissionId, assignableType, assignableId);
    } else {
      onCreate(assignableType, assignableId, permissionType);
    }
  };

  return (
    <div className="permission-item">
      <input
        id={id}
        type="checkbox"
        className={isSomething(permissionId) ? "checked" : "unchecked"}
        checked={isSomething(permissionId)}
        onChange={handleOnChange}
        disabled={disabled}
      />
      <label htmlFor={id}>
        <FormattedMessage id={labelId} />
      </label>
    </div>
  );
}

export default PermissionEdit;
